<template>
	<div class="drawer">
		<el-drawer
		v-if="detail._id"
		size="620px"
		title="礼品卡详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		style="display: flex;">
			<div class="page">
				<div class="pageLeft">
					<el-row class="row">
						<el-col :span="12">
							<span class="label">礼品卡名称：</span>
							<span class="value">{{detail.card_name}}</span>
						</el-col>
						<el-col :span="12">
							<span class="label">类型：</span>
							<span class="value">
								{{detail.card_type&&detail.card_type.title}}
							</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">卡号：</span>
							<span class="value">{{detail.card_number}}</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">面额：</span>
							<span class="value">{{detail.price}}</span>
						</el-col>
						<el-col :span="12">
							<span class="label">卡余额：</span>
							<span class="value">{{detail.surplus_money}}</span>
						</el-col>
					</el-row>
					<el-row class="row">
						<el-col :span="12">
							<span class="label">绑定时间：</span>
							<span class="value">{{$public.FTime(detail.bind_info.bind_time)}}</span>
						</el-col>
					</el-row>
				</div>
				<div class="pageRight">
					<div style="padding: 50px 20px 20px;">使用记录</div>
					<el-table :data="tableData" style="width: 100%">
						<el-table-column label="单号" width="100">
							<template slot-scope="scope">
								{{scope.row.order_no}}
							</template>
						</el-table-column>
						<el-table-column label="消费前" width="100">
							<template slot-scope="scope">
								{{scope.row.before_money}}
							</template>
						</el-table-column>
						<el-table-column label="消费金额" width="80">
							<template slot-scope="scope">
								{{scope.row.consume_money}}
							</template>
						</el-table-column>
						<el-table-column label="消费后" width="100">
							<template slot-scope="scope">
								{{scope.row.after_money}}
							</template>
						</el-table-column>
						<el-table-column label="消费地点" width="120">
							<template slot-scope="scope">
								{{scope.row.shop_info&&scope.row.shop_info.title}}
							</template>
						</el-table-column>
						<el-table-column label="消费时间" >
							<template slot-scope="scope">
								{{scope.row.create_info&&$public.FTime(scope.row.create_info.operation_time)}}
							</template>
						</el-table-column>
					</el-table>
					<div class="pageLine">
						<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
					</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import page from "../../../../components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				drawerStatus: false,
				detail: {},
				
				page:{
					page:1,
					pageSize:200,
					total:0
				},
				tableData:[],
				
			}
		},
		computed: {
			
		},
		props: {
			curItem: {
				default: () => {
					return {}
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.drawerStatus = true
				this.detail = this.curItem
				this.getTableData()
			})
		},
		methods: {
			handleClose() {
				this.$emit('submit', {type: 'close' })
			},
			
			changePage(num){
				this.page.page = num;
				this.getTableData()
			},
			getTableData(){
				let params = {
					cardNumber:this.detail.card_number,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_member+'/api/GiftCard/consumer/list', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer {
		width: 0;
		padding: 0 0 0 0;
		::v-deep.el-drawer {
			.label {
				display: inline-block;
				width: 150px;
				text-align: right;
			}
			.el-drawer__body{
				height: 100%;
				overflow-y: auto;
			}
		}
		.page{
			// 活动详情左侧
			.pageLeft {
				.row{
					padding:14px 5px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;border-bottom:1px solid #F2F2F2;
					.label{
						display: inline-block;width:150px;text-align: right;
					}
				}
			}
			// 活动详情右侧
			.pageRight{
				padding: 20px 0;
				display: flex;
				flex-direction: column;
				.comView {
					// width: 800px;
					min-height: 120px;
					border: 1px solid rgba(0, 0, 0, 0.15);
					border-radius: 2px;
					padding: 10px 10px 0 10px;
				
					.comItem {
						margin-right: 6px;
						margin-bottom: 10px;
						display: flex;
						align-items: center;
						line-height: 22px;
						font-size: 12px;
						display: inline-block;
						border-radius: 2px;
					}
				}
			}
			.l50{
				line-height: 50px;
			}
			.ar{
				text-align: right;
				color: #2a2a2a;
			}
			.leftItem{
				color: #6C6C6C;
				padding-left: 10px;
			}
			//头部信息
			.titleView {
				display: flex;
				align-items: center;
				padding-bottom: 16px;
				border-bottom: solid 1px #F5F5F5;
				padding-left: 5px;
				.line {
					width: 2px;
					height: 15px;
					background: $mainColor;
					margin-right: 5px;
				}
				.titleName {
					font-size: 14px;
					color: $fontColor;
				}
			}
		}
		
	}
</style>
